(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   Foil Style — PDP behavior
   Loaded by sections/main-product.liquid (referenced from theme.liquid or via
   {{ 'foil-product.js' | asset_url | script_tag }} at the end of the section).
   Reads all Liquid-provided values from data-* attributes + the JSON island,
   so it has zero Liquid dependencies.
   ========================================================================== */
(function () {
  function init(root) {
    if (!root || root.__foilInit) return;
    root.__foilInit = true;

    var presale = root.getAttribute('data-presale') === 'true';
    var klaviyoKey = root.getAttribute('data-klaviyo-key') || '';
    var klaviyoList = root.getAttribute('data-klaviyo-list') || '';
    var productTitle = root.getAttribute('data-product-title') || '';

    var variants = [];
    try {
      var island = root.querySelector('#foilVariantData');
      if (island) variants = JSON.parse(island.textContent || '[]');
    } catch (e) { variants = []; }

    var selected = {}; // optionIndex -> value

    /* ---------- gallery ---------- */
    var thumbs = root.querySelector('#foilThumbs');
    var mainImg = root.querySelector('#foilMainImg');
    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.foil-thumb');
        if (!btn) return;
        thumbs.querySelectorAll('.foil-thumb').forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
        mainImg.src = btn.getAttribute('data-src');
      });
    }

    /* ---------- swatches (color) ---------- */
    var swatches = root.querySelector('#foilSwatches');
    var colorVal = root.querySelector('#foilColorVal');
    if (swatches) {
      var ci = parseInt(swatches.getAttribute('data-option-index'), 10);
      var activeSw = swatches.querySelector('.foil-swatch.active');
      if (activeSw) selected[ci] = activeSw.getAttribute('data-name');
      swatches.addEventListener('click', function (e) {
        var s = e.target.closest('.foil-swatch');
        if (!s) return;
        swatches.querySelectorAll('.foil-swatch').forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        if (colorVal) colorVal.textContent = s.getAttribute('data-name');
        selected[ci] = s.getAttribute('data-name');
        recompute();
      });
    }

    /* ---------- sizes ---------- */
    var sizes = root.querySelector('#foilSizes');
    if (sizes) {
      var si = parseInt(sizes.getAttribute('data-option-index'), 10);
      var activeSz = sizes.querySelector('.foil-size.active');
      if (activeSz) selected[si] = activeSz.getAttribute('data-value');
      sizes.addEventListener('click', function (e) {
        var el = e.target.closest('.foil-size');
        if (!el || el.classList.contains('soldout')) return;
        sizes.querySelectorAll('.foil-size').forEach(function (x) { x.classList.remove('active'); });
        el.classList.add('active');
        selected[si] = el.getAttribute('data-value');
        recompute();
      });
    }

    /* ---------- variant matching (live mode) ---------- */
    var variantInput = root.querySelector('#foilVariantId');
    var priceEl = root.querySelector('#foilPrice');
    var priceAmt = root.querySelector('#foilPriceAmt');
    var addBtn = root.querySelector('#foilAddBtn');

    function findVariant() {
      var keys = Object.keys(selected);
      return variants.find(function (v) {
        return keys.every(function (k) {
          var idx = parseInt(k, 10); // option position 1..3
          return v['option' + idx] === selected[k];
        });
      });
    }
    function money(cents) {
      try { return '$' + (cents / 100).toFixed(2); } catch (e) { return ''; }
    }
    function recompute() {
      var v = findVariant();
      if (variantInput && v) variantInput.value = v.id;
      if (priceAmt && v) priceAmt.textContent = money(v.price);
      if (addBtn) {
        if (v && v.available) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
        else if (v) { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      }
    }

    /* ---------- qty ---------- */
    var qtyInput = root.querySelector('#foilQty');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = parseInt(b.getAttribute('data-qty'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
      });
    });

    /* ---------- accordion ---------- */
    var accordion = root.querySelector('#foilAccordion');
    if (accordion) {
      // if nothing is open by default (e.g. first panel hidden), open the first visible one
      if (!accordion.querySelector('.foil-acc-item.open')) {
        var firstItem = accordion.querySelector('.foil-acc-item');
        if (firstItem) firstItem.classList.add('open');
      }
      accordion.querySelectorAll('.foil-acc-item.open .foil-acc-body').forEach(function (b) {
        b.style.maxHeight = b.scrollHeight + 'px';
      });
      accordion.addEventListener('click', function (e) {
        var h = e.target.closest('.foil-acc-head');
        if (!h) return;
        var item = h.parentElement;
        var body = item.querySelector('.foil-acc-body');
        var open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    }

    /* ---------- notify modal + Klaviyo ---------- */
    var modal = root.querySelector('#foilModal');
    var notifyBtn = root.querySelector('#foilNotifyBtn');
    var modalX = root.querySelector('#foilModalX');
    var form = root.querySelector('#foilNotifyForm');
    var statusEl = root.querySelector('#foilNotifyStatus');
    var emailEl = root.querySelector('#foilNotifyEmail');

    function openModal() { if (modal) { modal.classList.add('show'); modal.setAttribute('aria-hidden', 'false'); setTimeout(function () { emailEl && emailEl.focus(); }, 60); } }
    function closeModal() { if (modal) { modal.classList.remove('show'); modal.setAttribute('aria-hidden', 'true'); } }

    if (notifyBtn) notifyBtn.addEventListener('click', openModal);
    if (modalX) modalX.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailEl.value || '').trim();
        if (!email) return;
        setStatus('Submitting…', '');

        if (!klaviyoKey || !klaviyoList) {
          // No Klaviyo configured yet — succeed gracefully so the UX still works in staging.
          setStatus("You're on the list. (Connect Klaviyo to capture live.)", 'ok');
          form.reset();
          return;
        }

        subscribeKlaviyo(email)
          .then(function () { setStatus("You're on the list. We'll be in touch — no spam.", 'ok'); form.reset(); })
          .catch(function () { setStatus('Something went wrong. Please try again.', 'err'); });
      });
    }

    function setStatus(msg, cls) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'foil-modal-status' + (cls ? ' ' + cls : '');
    }

    // Klaviyo Client API — public, browser-safe (subscribe to list).
    // Docs: POST https://a.klaviyo.com/client/subscriptions/?company_id=PUBLIC_KEY
    function subscribeKlaviyo(email) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { 'Interested Product': productTitle, 'Source': 'PDP Notify Me' }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: klaviyoList } } }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok && r.status !== 202) throw new Error('Klaviyo ' + r.status);
        return true;
      });
    }
  }

  function boot() {
    document.querySelectorAll('.foil-pdp-wrap').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Shopify theme editor re-render
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foil-imatter"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__imInit) return;
    root.__imInit = true;

    var variants = [];
    try { variants = JSON.parse((root.querySelector('#imVariantData') || {}).textContent || '[]'); } catch (e) {}
    var selected = {}, colorIdx = null, sizeIdx = null;

    var thumbs = root.querySelector('#imThumbs');
    var mainImg = root.querySelector('#imMainImg');
    var mainWrap = root.querySelector('.im-main-image');
    var mobileTrack = root.querySelector('#imMobileTrack');
    var dots = root.querySelector('#imGalleryDots');
    var prevArrow = root.querySelector('#imGalleryPrev');
    var nextArrow = root.querySelector('#imGalleryNext');
    var galleryItems = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll('.im-thumb')) : [];
    var galleryIndex = 0;

    function setActiveDot(index) {
      galleryIndex = index;
      if (!dots) return;
      dots.querySelectorAll('.im-gallery-dot').forEach(function (d) {
        d.classList.remove('active');
      });
      var activeDot = dots.querySelector('[data-index="' + galleryIndex + '"]');
      if (activeDot) activeDot.classList.add('active');
    }

    function setGalleryImage(index) {
      if (!galleryItems.length) return;

      if (index < 0) index = galleryItems.length - 1;
      if (index >= galleryItems.length) index = 0;

      galleryIndex = index;
      var active = galleryItems[galleryIndex];
      if (!active) return;

      galleryItems.forEach(function (t) { t.classList.remove('active'); });
      active.classList.add('active');

      if (mainImg) mainImg.src = active.getAttribute('data-src');
      setActiveDot(galleryIndex);
    }

    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.im-thumb');
        if (!btn) return;
        setGalleryImage(parseInt(btn.getAttribute('data-index'), 10) || 0);
      });
    }

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        setGalleryImage(galleryIndex - 1);
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        setGalleryImage(galleryIndex + 1);
      });
    }

    if (dots) {
      dots.addEventListener('click', function (e) {
        var dot = e.target.closest('.im-gallery-dot');
        if (!dot) return;

        var index = parseInt(dot.getAttribute('data-index'), 10) || 0;

        if (mobileTrack) {
          mobileTrack.scrollTo({
            left: mobileTrack.clientWidth * index,
            behavior: 'smooth'
          });
        }

        setGalleryImage(index);
        setActiveDot(index);
      });
    }

    if (mobileTrack && dots) {
      var mobileScrollTimer;

      mobileTrack.addEventListener('scroll', function () {
        clearTimeout(mobileScrollTimer);

        mobileScrollTimer = setTimeout(function () {
          var slideWidth = mobileTrack.clientWidth;
          if (!slideWidth) return;

          var index = Math.round(mobileTrack.scrollLeft / slideWidth);
          setActiveDot(index);
        }, 80);
      }, { passive: true });
    }

    if (mainWrap && galleryItems.length > 1) {
      var touchStartX = 0;
      var touchEndX = 0;

      mainWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mainWrap.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchEndX - touchStartX;

        if (Math.abs(diff) < 45) return;
        if (diff < 0) setGalleryImage(galleryIndex + 1);
        else setGalleryImage(galleryIndex - 1);
      }, { passive: true });
    }

    var swatches = root.querySelector('#imSwatches');
    var colorVal = root.querySelector('#imColorVal');
    if (swatches) {
      colorIdx = parseInt(swatches.getAttribute('data-option-index'), 10);
      var a = swatches.querySelector('.im-swatch.active'); if (a) selected[colorIdx] = a.getAttribute('data-name');
      swatches.addEventListener('click', function (e) {
        var s = e.target.closest('.im-swatch'); if (!s) return;
        swatches.querySelectorAll('.im-swatch').forEach(function (x){x.classList.remove('active');});
        s.classList.add('active');
        if (colorVal) colorVal.textContent = s.getAttribute('data-name');
        selected[colorIdx] = s.getAttribute('data-name');
        updateSizeAvailability(); recompute();
      });
    }

    var sizes = root.querySelector('#imSizes');
    if (sizes) {
      sizeIdx = parseInt(sizes.getAttribute('data-option-index'), 10);
      var az = sizes.querySelector('.im-size.active'); if (az) selected[sizeIdx] = az.getAttribute('data-value');
      sizes.addEventListener('click', function (e) {
        var el = e.target.closest('.im-size'); if (!el || el.classList.contains('soldout')) return;
        sizes.querySelectorAll('.im-size').forEach(function (x){x.classList.remove('active');});
        el.classList.add('active'); selected[sizeIdx] = el.getAttribute('data-value'); recompute();
      });
    }

    var variantInput = root.querySelector('#imVariantId');
    var priceAmt = root.querySelector('#imPriceAmt');
    var priceWas = root.querySelector('#imPriceWas');
    var addBtn = root.querySelector('#imAddBtn');
    var addLbl = addBtn ? addBtn.querySelector('.lbl') : null;
    function setLabel(t){ if (addLbl) addLbl.textContent = t; else if (addBtn) addBtn.textContent = t; }

    function findVariant(){
      var keys = Object.keys(selected);
      return variants.find(function (v){ return keys.every(function (k){ return v['option'+parseInt(k,10)] === selected[k]; }); });
    }
    function money(c){ try { return '$' + (c/100).toFixed(2); } catch (e){ return ''; } }
    function updateSizeAvailability(){
      if (!sizes || colorIdx == null || sizeIdx == null) return;
      sizes.querySelectorAll('.im-size').forEach(function (el){
        var sv = el.getAttribute('data-value');
        var m = variants.find(function (v){ return v['option'+colorIdx] === selected[colorIdx] && v['option'+sizeIdx] === sv; });
        var ok = m && m.available;
        el.classList.toggle('soldout', !ok);
        if (!ok && el.classList.contains('active')) { el.classList.remove('active'); delete selected[sizeIdx]; }
      });
    }
    function recompute(){
      var v = findVariant();
      if (variantInput && v) variantInput.value = v.id;
      if (priceAmt && v) priceAmt.textContent = money(v.price);
      if (v && priceWas){
        if (v.compare_at_price && v.compare_at_price > v.price){ priceWas.style.display=''; priceWas.textContent=money(v.compare_at_price); }
        else priceWas.style.display='none';
      }
      if (v && v.featured_image && v.featured_image.src && mainImg) mainImg.src = v.featured_image.src;
      if (addBtn){
        if (v && v.available){ addBtn.disabled=false; setLabel('Add to Cart'); }
        else if (v){ addBtn.disabled=true; setLabel('Sold Out'); }
        else { addBtn.disabled=true; setLabel('Select Options'); }
      }
    }

    var qtyInput = root.querySelector('#imQty');
    root.querySelectorAll('[data-qty]').forEach(function (b){
      b.addEventListener('click', function (){ if (!qtyInput) return; var d=parseInt(b.getAttribute('data-qty'),10); qtyInput.value=Math.max(1,(parseInt(qtyInput.value,10)||1)+d); });
    });

    var accordion = root.querySelector('#imAccordion');
    if (accordion) {
      accordion.querySelectorAll('.im-acc-body').forEach(function (body) {
        body.style.maxHeight = '0';
      });

      accordion.addEventListener('click', function (e){
        var h = e.target.closest('.im-acc-head'); if (!h) return;
        var item = h.parentElement, body = item.querySelector('.im-acc-body');
        var open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    }

    updateSizeAvailability();
    recompute();
  }
  function boot(){ document.querySelectorAll('.foil-imatter').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foil-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__foilInit) return;
    root.__foilInit = true;
    var presale = root.getAttribute('data-presale') === 'true';
    var variants = [];
    try {
      var island = root.querySelector('#foilVariantData');
      if (island) variants = JSON.parse(island.textContent || '[]');
    } catch (e) { variants = []; }
    var selected = {};

    /* Gallery: one image list also supports single-image products. */
    var thumbs = root.querySelector('#foilThumbs');
    var mainImg = root.querySelector('#foilMainImg');
    var mainWrap = root.querySelector('.foil-main-image');
    var dots = root.querySelector('#foilGalleryDots');
    var prevArrow = root.querySelector('#foilGalleryPrev');
    var nextArrow = root.querySelector('#foilGalleryNext');
    var mobileTrack = root.querySelector('#foilMobileTrack');
    var galleryItems = Array.prototype.slice.call(root.querySelectorAll('.foil-mobile-slide[data-image-id]'));
    var galleryIndex = 0;

    function setActiveDot(index) {
      galleryIndex = index;
      if (!dots) return;
      dots.querySelectorAll('.foil-gallery-dot').forEach(function (dot) {
        var active = Number(dot.getAttribute('data-index')) === index;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
    function setGalleryImage(index) {
      if (!galleryItems.length) return;
      index = (index + galleryItems.length) % galleryItems.length;
      var image = galleryItems[index].querySelector('img');
      if (!image) return;
      if (mainImg) {
        mainImg.src = image.getAttribute('src');
        mainImg.alt = image.getAttribute('alt') || '';
        mainImg.width = image.width;
        mainImg.height = image.height;
      }
      if (thumbs) {
        thumbs.querySelectorAll('.foil-thumb').forEach(function (thumb) {
          var active = Number(thumb.getAttribute('data-index')) === index;
          thumb.classList.toggle('active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
      setActiveDot(index);
    }
    function scrollMobileTo(index) {
      if (mobileTrack && mobileTrack.clientWidth) {
        mobileTrack.scrollTo({left:mobileTrack.clientWidth * index, behavior:'smooth'});
      }
    }
    function showVariantImage(variant) {
      if (!variant || !variant.featured_image_id) return;
      var index = galleryItems.findIndex(function (item) {
        return item.getAttribute('data-image-id') === String(variant.featured_image_id);
      });
      if (index < 0) return;
      setGalleryImage(index);
      scrollMobileTo(index);
    }
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var button = e.target.closest('.foil-thumb');
      if (!button) return;
      var index = Number(button.getAttribute('data-index')) || 0;
      setGalleryImage(index);
      scrollMobileTo(index);
    });
    if (prevArrow) prevArrow.addEventListener('click', function () {setGalleryImage(galleryIndex - 1);});
    if (nextArrow) nextArrow.addEventListener('click', function () {setGalleryImage(galleryIndex + 1);});
    if (dots) dots.addEventListener('click', function (e) {
      var dot = e.target.closest('.foil-gallery-dot');
      if (!dot) return;
      var index = Number(dot.getAttribute('data-index')) || 0;
      setGalleryImage(index);
      scrollMobileTo(index);
    });
    if (mobileTrack) {
      var mobileScrollTimer;
      mobileTrack.addEventListener('scroll', function () {
        clearTimeout(mobileScrollTimer);
        mobileScrollTimer = setTimeout(function () {
          var width = mobileTrack.clientWidth;
          if (!width || !galleryItems.length) return;
          setGalleryImage(Math.max(0, Math.min(galleryItems.length - 1, Math.round(mobileTrack.scrollLeft / width))));
        }, 80);
      }, {passive:true});
    }
    var suppressMainClickUntil = 0;
    if (mainWrap && galleryItems.length > 1) {
      var mainTouchStart = null;
      mainWrap.addEventListener('touchstart', function (e) {
        mainTouchStart = e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
      }, {passive:true});
      mainWrap.addEventListener('touchend', function (e) {
        if (!mainTouchStart) return;
        var dx = e.changedTouches[0].clientX - mainTouchStart.x;
        var dy = e.changedTouches[0].clientY - mainTouchStart.y;
        mainTouchStart = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
        suppressMainClickUntil = Date.now() + 500;
        setGalleryImage(galleryIndex + (dx < 0 ? 1 : -1));
      }, {passive:true});
    }

    /* Enlarged gallery: native dialog provides focus trapping and Escape. */
    (function initPhotoViewer() {
      if (!galleryItems.length || typeof HTMLDialogElement === 'undefined') return;
      var photos = galleryItems.map(function (slide) {
        var image = slide.querySelector('img');
        return {src:image.getAttribute('src'),alt:image.getAttribute('alt') || ''};
      });
      var dialog = document.createElement('dialog');
      dialog.className = 'foil-photo-dialog';
      dialog.setAttribute('aria-label', 'Product image gallery');
      dialog.innerHTML =
        '<div class="foil-photo-toolbar">' +
          '<span class="foil-photo-count" role="status" aria-live="polite"></span>' +
          '<div class="foil-photo-actions">' +
            '<button type="button" data-photo-zoom aria-pressed="false">Zoom in</button>' +
            '<button type="button" data-photo-close aria-label="Close product image gallery">Close ✕</button>' +
          '</div>' +
        '</div>' +
        '<div class="foil-photo-stage"><img alt="" draggable="false"></div>' +
        '<div class="foil-photo-navigation">' +
          '<button type="button" data-photo-prev aria-label="Previous product image">← Previous</button>' +
          '<button type="button" data-photo-next aria-label="Next product image">Next →</button>' +
        '</div>';
      root.appendChild(dialog);
      var stage = dialog.querySelector('.foil-photo-stage');
      var viewerImage = stage.querySelector('img');
      var count = dialog.querySelector('.foil-photo-count');
      var zoomButton = dialog.querySelector('[data-photo-zoom]');
      var closeButton = dialog.querySelector('[data-photo-close]');
      var navigation = dialog.querySelector('.foil-photo-navigation');
      var viewerIndex = 0;
      var zoomed = false;
      var returnFocus = null;
      var previousOverflow = '';
      navigation.hidden = photos.length < 2;
      function setZoom(nextZoom) {
        zoomed = nextZoom;
        stage.classList.toggle('is-zoomed', zoomed);
        zoomButton.textContent = zoomed ? 'Zoom out' : 'Zoom in';
        zoomButton.setAttribute('aria-pressed', String(zoomed));
        stage.scrollTop = 0;
        stage.scrollLeft = 0;
      }
      function renderPhoto(index) {
        viewerIndex = (index + photos.length) % photos.length;
        viewerImage.src = photos[viewerIndex].src;
        viewerImage.alt = photos[viewerIndex].alt;
        count.textContent = (viewerIndex + 1) + ' / ' + photos.length;
        setZoom(false);
      }
      function openViewer(index, trigger) {
        if (dialog.open) return;
        returnFocus = trigger;
        renderPhoto(index);
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        closeButton.focus();
      }
      function addOpenButton(container, getIndex) {
        if (!container) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'foil-photo-open';
        button.setAttribute('aria-label', 'Enlarge product image');
        button.setAttribute('aria-haspopup', 'dialog');
        button.innerHTML = '<span aria-hidden="true">＋ Zoom</span>';
        button.addEventListener('click', function () {
          if (Date.now() < suppressMainClickUntil) return;
          openViewer(getIndex(), button);
        });
        container.appendChild(button);
      }
      addOpenButton(mainWrap, function () {return galleryIndex;});
      galleryItems.forEach(function (slide, index) {
        addOpenButton(slide, function () {return index;});
      });
      closeButton.addEventListener('click', function () {dialog.close();});
      dialog.addEventListener('close', function () {
        document.body.style.overflow = previousOverflow;
        setZoom(false);
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
      });
      zoomButton.addEventListener('click', function () {setZoom(!zoomed);});
      var tapStart = null;
      stage.addEventListener('pointerdown', function (e) {
        if (!e.isPrimary) {tapStart = null;return;}
        tapStart = {x:e.clientX,y:e.clientY,time:Date.now()};
      });
      stage.addEventListener('pointercancel', function () {tapStart = null;});
      stage.addEventListener('pointerup', function (e) {
        if (!tapStart || !e.isPrimary) return;
        var distance = Math.hypot(e.clientX - tapStart.x,e.clientY - tapStart.y);
        var elapsed = Date.now() - tapStart.time;
        tapStart = null;
        if (distance < 10 && elapsed < 400) setZoom(!zoomed);
      });
      dialog.querySelector('[data-photo-prev]').addEventListener('click', function () {renderPhoto(viewerIndex - 1);});
      dialog.querySelector('[data-photo-next]').addEventListener('click', function () {renderPhoto(viewerIndex + 1);});
      dialog.addEventListener('keydown', function (e) {
        if (zoomed) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          renderPhoto(viewerIndex + (e.key === 'ArrowRight' ? 1 : -1));
        }
      });
      var swipeStart = null;
      stage.addEventListener('touchstart', function (e) {
        swipeStart = !zoomed && e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
        if (e.touches.length > 1) tapStart = null;
      }, {passive:true});
      stage.addEventListener('touchcancel', function () {swipeStart = null;tapStart = null;}, {passive:true});
      stage.addEventListener('touchend', function (e) {
        if (!swipeStart || zoomed) return;
        var dx = e.changedTouches[0].clientX - swipeStart.x;
        var dy = e.changedTouches[0].clientY - swipeStart.y;
        swipeStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) renderPhoto(viewerIndex + (dx < 0 ? 1 : -1));
      }, {passive:true});
    })();

    /* Color, cut and size selectors. */
    var swatches = root.querySelector('#foilSwatches');
    var colorVal = root.querySelector('#foilColorVal');
    if (swatches) {
      var ci = parseInt(swatches.getAttribute('data-option-index'),10);
      var activeSw = swatches.querySelector('.foil-swatch.active');
      if (activeSw) selected[ci] = activeSw.getAttribute('data-name');
      swatches.addEventListener('click', function (e) {
        var s = e.target.closest('.foil-swatch');
        if (!s) return;
        swatches.querySelectorAll('.foil-swatch').forEach(function (x) {x.classList.remove('active');});
        s.classList.add('active');
        if (colorVal) colorVal.textContent = s.getAttribute('data-display-name') || s.getAttribute('data-name');
        selected[ci] = s.getAttribute('data-name');
        recompute();
      });
    }
    var cuts = root.querySelector('#foilCuts');
    if (cuts) {
      var cutIndex = parseInt(cuts.getAttribute('data-option-index'),10);
      var activeCut = cuts.querySelector('.foil-cut.active');
      if (activeCut) selected[cutIndex] = activeCut.getAttribute('data-value');
      cuts.addEventListener('click', function (e) {
        var el = e.target.closest('.foil-cut');
        if (!el || el.classList.contains('soldout')) return;
        cuts.querySelectorAll('.foil-cut').forEach(function (x) {x.classList.remove('active');});
        el.classList.add('active');
        selected[cutIndex] = el.getAttribute('data-value');
        recompute();
      });
    }
    var sizes = root.querySelector('#foilSizes');
    if (sizes) {
      var si = parseInt(sizes.getAttribute('data-option-index'),10);
      var activeSz = sizes.querySelector('.foil-size.active');
      if (activeSz) selected[si] = activeSz.getAttribute('data-value');
      sizes.addEventListener('click', function (e) {
        var el = e.target.closest('.foil-size');
        if (!el || el.classList.contains('soldout')) return;
        sizes.querySelectorAll('.foil-size').forEach(function (x) {x.classList.remove('active');});
        el.classList.add('active');
        selected[si] = el.getAttribute('data-value');
        recompute();
      });
    }
    var variantInput = root.querySelector('#foilVariantId');
    var priceAmt = root.querySelector('#foilPriceAmt');
    var addBtn = root.querySelector('#foilAddBtn');
    function findVariant() {
      var keys = Object.keys(selected);
      if (!variants.length) return null;
      if (!keys.length) {
        return variants.find(function (v) {return variantInput && String(v.id) === variantInput.value;}) || variants[0];
      }
      return variants.find(function (v) {
        return keys.every(function (k) {return v['option' + parseInt(k,10)] === selected[k];});
      }) || null;
    }
    /* Liquid supplies the store's own money formatting for every variant. */
    function formattedMoney(v, key) {
      var text = document.createElement('span');
      text.innerHTML = v[key] || '';
      return text.textContent || '';
    }
    function recompute() {
      var guidance = root.querySelector('[data-cut-guidance]');
      if (guidance && cuts) {
        var isFitted = String(selected[cutIndex] || '').toLowerCase().indexOf('fitted') !== -1;
        var label = guidance.querySelector('[data-cut-guidance-label]');
        var copy = guidance.querySelector('[data-cut-guidance-copy]');
        if (label) label.textContent = isFitted ? 'Fitted fit:' : 'Relaxed fit:';
        if (copy) copy.textContent = isFitted ? 'Closer through the shoulders and waist for a tailored silhouette.' : 'Room through the chest and body for movement and layering.';
      }
      var v = findVariant();
      if (variantInput) variantInput.value = v ? v.id : '';
      if (priceAmt && v) priceAmt.textContent = formattedMoney(v,'formatted_price');
      var priceWrap = root.querySelector('#foilPrice');
      var priceWas = root.querySelector('#foilPriceWas');
      if (v && priceWrap) {
        if (v.compare_at_price > v.price) {
          if (!priceWas) {
            priceWas = document.createElement('s');
            priceWas.id = 'foilPriceWas';
            priceWas.className = 'foil-was';
            priceWrap.appendChild(priceWas);
          }
          priceWas.textContent = formattedMoney(v,'formatted_compare_at_price');
        } else if (priceWas) priceWas.remove();
      }
      if (v) showVariantImage(v);
      if (!addBtn) return;
      addBtn.disabled = !(v && v.available);
      addBtn.textContent = v && v.available ? 'Add to Bag · ' + formattedMoney(v,'formatted_price') : v ? 'Sold Out' : 'Unavailable';
    }
    var linkedVariantId = new URLSearchParams(window.location.search).get('variant');
    if (linkedVariantId) {
      var linkedVariant = variants.find(function (v) {return String(v.id) === linkedVariantId;});
      if (linkedVariant) showVariantImage(linkedVariant);
    }

    /* Quantity and accordions. */
    var qtyInput = root.querySelector('#foilQty');
    root.querySelectorAll('[data-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!qtyInput) return;
        var delta = parseInt(button.getAttribute('data-qty'),10);
        qtyInput.value = Math.max(1,(parseInt(qtyInput.value,10) || 1) + delta);
      });
    });
    var accordion = root.querySelector('#foilAccordion');
    if (accordion) {
      accordion.querySelectorAll('.foil-acc-body').forEach(function (body) {body.style.maxHeight = '0';});
      accordion.addEventListener('click', function (e) {
        var head = e.target.closest('.foil-acc-head');
        if (!head || !head.parentElement) return;
        var item = head.parentElement;
        var body = item.querySelector('.foil-acc-body');
        if (!body) return;
        var open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    }

    /* Size guide modal and matching guide tabs. */
    var sizeGuideModal = root.querySelector('[data-size-guide-modal]');
    var sizeGuideButtons = root.querySelectorAll('[data-size-guide-open]');
    var sizeGuideClose = root.querySelector('[data-size-guide-close]');
    var sizeGuideTabs = sizeGuideModal ? Array.prototype.slice.call(sizeGuideModal.querySelectorAll('[data-size-guide-tab]')) : [];
    var sizeGuidePanels = sizeGuideModal ? Array.prototype.slice.call(sizeGuideModal.querySelectorAll('[data-size-guide-panel]')) : [];
    var activeSizeGuideTrigger = null;
    var sizeGuidePreviousOverflow = '';
    function normalizeGuideValue(value) {return String(value || '').trim().toLowerCase();}
    function activateSizeGuide(index) {
      if (!sizeGuideTabs.length || !sizeGuidePanels.length) return;
      sizeGuideTabs.forEach(function (tab) {
        var active = tab.getAttribute('data-guide-index') === String(index);
        tab.classList.toggle('active',active);
        tab.setAttribute('aria-selected',active ? 'true' : 'false');
        tab.setAttribute('tabindex',active ? '0' : '-1');
      });
      sizeGuidePanels.forEach(function (panel) {
        var active = panel.getAttribute('data-guide-index') === String(index);
        panel.classList.toggle('active',active);
        panel.hidden = !active;
      });
    }
    function activateGuideForSelectedCut() {
      if (!sizeGuideTabs.length) return;
      var activeCut = root.querySelector('.foil-cut.active');
      var selectedCut = activeCut ? normalizeGuideValue(activeCut.getAttribute('data-value') || activeCut.textContent) : '';
      var match = null;
      if (selectedCut) {
        match = sizeGuideTabs.find(function (tab) {return normalizeGuideValue(tab.getAttribute('data-guide-match')) === selectedCut;});
        if (!match) match = sizeGuideTabs.find(function (tab) {
          var value = normalizeGuideValue(tab.getAttribute('data-guide-match'));
          return value && (value.indexOf(selectedCut) !== -1 || selectedCut.indexOf(value) !== -1);
        });
      }
      activateSizeGuide((match || sizeGuideTabs[0]).getAttribute('data-guide-index') || '0');
    }
    function openSizeGuide(event) {
      if (!sizeGuideModal || sizeGuideModal.classList.contains('show')) return;
      activeSizeGuideTrigger = event && event.currentTarget ? event.currentTarget : null;
      activateGuideForSelectedCut();
      sizeGuidePreviousOverflow = document.body.style.overflow;
      sizeGuideModal.classList.add('show');
      sizeGuideModal.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {if (sizeGuideClose) sizeGuideClose.focus();},60);
    }
    function closeSizeGuide() {
      if (!sizeGuideModal || !sizeGuideModal.classList.contains('show')) return;
      sizeGuideModal.classList.remove('show');
      sizeGuideModal.setAttribute('aria-hidden','true');
      document.body.style.overflow = sizeGuidePreviousOverflow;
      if (activeSizeGuideTrigger) activeSizeGuideTrigger.focus();
      activeSizeGuideTrigger = null;
    }
    sizeGuideButtons.forEach(function (button) {button.addEventListener('click',openSizeGuide);});
    sizeGuideTabs.forEach(function (tab) {
      tab.addEventListener('click',function () {activateSizeGuide(tab.getAttribute('data-guide-index') || '0');});
      tab.addEventListener('keydown',function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var index = (sizeGuideTabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1) + sizeGuideTabs.length) % sizeGuideTabs.length;
        var nextTab = sizeGuideTabs[index];
        activateSizeGuide(nextTab.getAttribute('data-guide-index') || '0');
        nextTab.focus();
      });
    });
    if (sizeGuideClose) sizeGuideClose.addEventListener('click',closeSizeGuide);
    if (sizeGuideModal) sizeGuideModal.addEventListener('click',function (e) {if (e.target === sizeGuideModal) closeSizeGuide();});

    /* Notify modal and native Shopify newsletter. */
    var modal = root.querySelector('#foilModal');
    var notifyBtn = root.querySelector('#foilNotifyBtn');
    var modalX = root.querySelector('#foilModalX');
    var form = root.querySelector('#foilNotifyForm');
    var statusEl = root.querySelector('#foilNotifyStatus');
    var emailEl = root.querySelector('#foilNotifyEmail');
    function openModal() {
      if (!modal) return;
      modal.classList.add('show');
      modal.setAttribute('aria-hidden','false');
      setTimeout(function () {if (emailEl) emailEl.focus();},60);
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden','true');
    }
    if (notifyBtn) notifyBtn.addEventListener('click',openModal);
    if (modalX) modalX.addEventListener('click',closeModal);
    if (modal) modal.addEventListener('click',function (e) {if (e.target === modal) closeModal();});
    document.addEventListener('keydown',function (e) {
      if (!root.isConnected || e.key !== 'Escape') return;
      if (root.querySelector('.foil-photo-dialog[open]')) return;
      if (sizeGuideModal && sizeGuideModal.classList.contains('show')) {closeSizeGuide();return;}
      closeModal();
    });
    if (form) form.addEventListener('submit',function (e) {
      e.preventDefault();
      var email = (emailEl.value || '').trim();
      if (!email) return;
      setStatus('Submitting…','');
      var submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = true;
      fetch(form.action,{
        method:'POST',body:new FormData(form),credentials:'same-origin',headers:{'Accept':'text/html'}
      }).then(function (response) {
        /* Retains the existing newsletter submission behavior. */
        if (response.status >= 500) throw new Error('Shopify newsletter submission failed');
        setStatus("You're on the list. We'll be in touch — no spam.",'ok');
        form.reset();
      }).catch(function () {
        setStatus('Something went wrong. Please check your email and try again.','err');
      }).finally(function () {if (submitButton) submitButton.disabled = false;});
    });
    function setStatus(message,cls) {
      if (!statusEl) return;
      statusEl.textContent = message;
      statusEl.className = 'foil-modal-status' + (cls ? ' ' + cls : '');
    }
  }
  function boot() {document.querySelectorAll('.foil-pdp-wrap').forEach(init);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
